module.exports = __webpack_public_path__ + "static/media/intro_image.7650fcfc.webp";